module.exports = __webpack_public_path__ + "img/video-player/joy-507651fe2c4509dd88e2e202df8fff2f.png";